import { Trans, useTranslation } from 'react-i18next';
import { StringUtils } from '@/common/utils/string';
import { TimelineSteps } from '@/web/components/TimelineSteps/TimelineSteps';
import {
  IconCoverflexApp,
  IconCreditCard,
  IconLock,
  Text,
} from '@coverflex-tech/hypernova';
import { ArrayUtils } from '@coverflex-tech/hypernova-utils';
import { css } from './NewCardSteps.css';

type TNewCardStepsProps = {
  phoneNumber?: string;
  isExpirationRenewal?: boolean;
};

export function NewCardSteps({
  phoneNumber,
  isExpirationRenewal,
}: TNewCardStepsProps) {
  const { t } = useTranslation();
  return (
    <TimelineSteps
      items={[
        phoneNumber
          ? {
              icon: <IconLock />,
              content: (
                <Text>
                  <Trans
                    i18nKey="activate_card.success.items.sms"
                    values={{
                      phoneNumber: StringUtils.formatPhoneNumber(phoneNumber),
                    }}
                  />
                </Text>
              ),
            }
          : undefined,
        {
          icon: <IconCreditCard />,
          content: (
            <Text>{t('activate_card.success.items.first_payment')}</Text>
          ),
        },
        {
          icon: <IconCoverflexApp />,
          content: <Text>{t('activate_card.success.items.atm_check')}</Text>,
        },
        isExpirationRenewal
          ? {
              badgeClassName: css.attentionBadge,
              icon: <IconCreditCard themeColor="neutral10" />,
              content: (
                <Text>
                  {t('activate_card.success.items.expiration_renewal')}
                </Text>
              ),
            }
          : undefined,
      ].filter(ArrayUtils.removeFalsey)}
    />
  );
}
